import { Component, OnInit, Input } from '@angular/core';
import { CatalogosSatService } from '../../../../services/catalogos-sat-service';
import { CuentasPorCobrarService } from '../../../../services/cuentas-por-cobrar.service';
import { ObrasService } from '../../../../services/obras.service';
@Component({
  selector: 'app-visualizar-contrato',
  templateUrl: './visualizar-contrato.component.html',
  styleUrls: ['./visualizar-contrato.component.scss']
})

export class VisualizarContratoComponent implements OnInit {
  
  @Input() public contrato: any={};

  public id_contrato;
  public nombreEmisor;
  public nombre_emisor_mantenimiento;
  public nombre_emisor_servicio;
  public nombre_arrendatario;
  public nombre_obra;
  public mostrarApoderado = false;
  public mostrarObligado = false;
  public apoderado_legal: any={};
  public obligado_solidario: any={};
  public concepto: any=[];
  public concepto_r: any={};
  public concepto_m: {};
  public concepto_s: {};
  public tipoServicio: any;
  public descripcion_cfdi;


  constructor(private obrasService: ObrasService,
              private catalogosSatService: CatalogosSatService,
              private cuentasPorCobrarService: CuentasPorCobrarService) { }

  ngOnInit() {
    this.id_contrato = this.contrato.id_contrato;
    
    this.usoCFDI();
    this.loadServicios();
    this.loadEmisores();
    this.loadArrendatarios();
    this.loadConceptos();
    this.obligado_apoderado();
    this.mostrarApoderadoObligado();
  }

  private usoCFDI(){
    this.catalogosSatService.obtenerUsosCFDI().subscribe((response) => {
        let usosCFDI = response.json().content;
        usosCFDI.some(usoDelCFDI => {
          if(usoDelCFDI.codigo === this.contrato.uso_cfdi){
            this.descripcion_cfdi = usoDelCFDI.descripcion;
            return true;
          }
          return false;
        });
    });
  }

  loadArrendatarios(){
    this.cuentasPorCobrarService.getTiposArrendatarios()
    .subscribe((response)=>{
      let arrendatario = response.json().content;
      for (var i=0;i<arrendatario.length;i++){
        var arre = arrendatario[i];
        if(arre.id_tipo_arrendatario === this.contrato.proveedor.id_tipo_arrendatario){
          this.nombre_arrendatario = arre.nombre;
          return true;
        }else return false;
      }
    });
  }

  loadServicios(){
    this.cuentasPorCobrarService.getAllTiposServicio()
    .subscribe((response)=>{
      let servicio = response.json().content;
      console.log(servicio);
      for (var i=0;i<servicio.length;i++){
        var s = servicio[i];
        if(s.id_servicio === this.contrato.servicios.id_tipo_servicio){
          this.tipoServicio = s.nombre;
          return true;
        }else return false;
      }
    });
  }

  loadEmisores(){
    this.obrasService.getObras()
    .subscribe((response)=>{
      let obras = response.json().content;
      
      //Nombre emisor
      for (var i=0;i<obras.length;i++){
        var obra = obras[i];
        if(obra.idObras === this.contrato.id_emisor){
          this.nombreEmisor = obra.nombreHub;
        }
      }

      //Nombre emisor mantenimiento
      for (var i=0;i<obras.length;i++){
        var obra = obras[i];
        if(obra.idObras === this.contrato.id_emisor_mantenimiento){
          this.nombre_emisor_mantenimiento = obra.nombreHub;
        }
      }

      //Nombre emisor servicio
      for (var i=0;i<obras.length;i++){
        var obra = obras[i];
        if(obra.idObras === this.contrato.id_emisor_servicios){
          this.nombre_emisor_servicio = obra.nombreHub;
        }
      }

      //Nombre del Inmueble (obra)
      for (var i=0;i<obras.length;i++){
        var obra = obras[i];
        if(obra.idObras === this.contrato.id_obra){
          this.nombre_obra = obra.nombreHub;
        }
      }
    });
  }

  mostrarApoderadoObligado() {
    if (this.contrato.proveedor.tipo_persona == 'moral'){
      this.mostrarApoderado = true;
    }
    if (this.contrato.proveedor.id_tipo_arrendatario === 1 || this.contrato.proveedor.id_tipo_arrendatario == null){
      this.mostrarObligado = false;
    }else this.mostrarObligado = true;
  }

  loadConceptos(){
    this.cuentasPorCobrarService.getAllConceptosVisiblesEnContratos()
    .subscribe((response)=>{
        let conceptos = response.json().content;
        this.concepto = conceptos;
        this.conceptoR(conceptos);
        this.conceptoM(conceptos);
        this.conceptoS(conceptos);
    });
  }

  //Concepto de Renta
  conceptoR(conceptos){
    for (var i=0;i<conceptos.length;i++){
      var c = conceptos[i];
      for (var j=0;j<this.contrato.rentas.length;j++){
        var r = this.contrato.rentas[j];
        if (r.id_concepto === c.idConceptos){
            this.concepto_r.nombre = c.descripcion;
            console.log(this.concepto_r.nombre);
        }
      }
    }
  }

  //Concepto de Mantenimiento
  conceptoM(conceptos){
    for (var i=0;i<conceptos.length;i++){
      var c = conceptos[i];
      for (var j=0;j<this.contrato.mantenimientos.length;j++){
        var m = this.contrato.mantenimientos[j];
        if (m.id_concepto === c.idConceptos){
            this.concepto_m = c.descripcion;
            return true;
        } else return false;
      }
    }
  }

  //Concepto de Servicio
  conceptoS(conceptos){
    for (var i=0;i<conceptos.length;i++){
      var c = conceptos[i];
      for (var j=0;j<this.contrato.servicios.length;j++){
        var s = this.contrato.servicios[j];
        if (s.id_concepto === c.idConceptos){
            this.concepto_s = c.descripcion;
            return true;
        } else return false;
      }
    }
  }
  
  obligado_apoderado(){
    let contrato = this.contrato.obligados_solidarios;
    for (var i=0;i<this.contrato.obligados_solidarios.length;i++){
      var os = this.contrato.obligados_solidarios[i];
      if (os.es_apoderado_legal){
        this.apoderado_legal.nombre = os.nombre;
        this.apoderado_legal.direccion = os.domicilio;
        this.apoderado_legal.telefono = os.telefono;
        this.apoderado_legal.email = os.email;
        this.apoderado_legal.rfc = os.rfc;
      }else{
        this.obligado_solidario.nombre = os.nombre;
        this.obligado_solidario.direccion = os.domicilio;
        this.obligado_solidario.direccion_oficina = os.domicilio_oficina;
        this.obligado_solidario.telefono = os.telefono;
        this.obligado_solidario.telefono_oficina = os.telefono_oficina;
        this.obligado_solidario.email = os.email;
        this.obligado_solidario.rfc = os.rfc;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/visualizar-contrato/visualizar-contrato.component.ts